"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var React = require("react");
var form_element_hook_1 = require("./form-element-hook");
var mailing_address_1 = require("./mailing-address");
var org_admin_fields_1 = require("./org-admin-fields");
var react_hook_form_1 = require("react-hook-form");
var validation_1 = require("../../core/validation");
var react_apollo_1 = require("react-apollo");
var apollo_helpers_1 = require("../../core/apollo-helpers");
var QueryOrganization = require("../../core/gql/queries/show-organizations");
var UpdateOrganizationAdmin = require("../../core/gql/mutations/update-organization-admin");
var UpdateOrganization = require("../../core/gql/mutations/update-organization");
var CreateOrganization = require("../../core/gql/mutations/create-organization");
var AllOrganizations = require("../../core/gql/queries/all-organizations");
var ShowOrganization = require("../../core/gql/queries/show-organizations");
var SetFeedbackMessage = require("../../core/gql/mutations/set-feedback-message");
var serialization_1 = require("../../core/serialization");
var organization_1 = require("../../models/organization");
var CreateElement = form_element_hook_1.default;
var OrganizationEditForm = function (_a) {
    var isModal = _a.isModal, employeeView = _a.employeeView, selectedOrganizationId = _a.selectedOrganizationId, onFinish = _a.onFinish;
    var options = {
        refetchQueries: [
            { query: AllOrganizations.QUERY },
            { query: ShowOrganization.QUERY, variables: { organizationId: selectedOrganizationId } },
        ],
    };
    var _b = react_apollo_1.useMutation(CreateOrganization.MUTATION, options), createOrganization = _b[0], createOrganizationResponse = _b[1];
    var _c = react_apollo_1.useMutation(UpdateOrganization.MUTATION, options), updateOrganization = _c[0], updateOrganizationResponse = _c[1];
    var setFeedbackMessage = react_apollo_1.useMutation(SetFeedbackMessage.MUTATION)[0];
    var _d = react_apollo_1.useMutation(UpdateOrganizationAdmin.MUTATION, options), updateOrganizationAsAdmin = _d[0], updateOrganizationAsAdminResponse = _d[1];
    var submit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var variables, e_1, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    variables = {
                        id: selectedOrganizationId,
                        ownerEmail: values.ownerEmail,
                        ownerFirstName: values.ownerFirstName,
                        ownerLastName: values.ownerLastName,
                        businessType: values.businessType,
                        country: values.country,
                        name: values.name,
                        notes: values.notes,
                        numberOfTeamsPaidFor: +values.numberOfTeamsPaidFor,
                        paymentProvider: values.paymentProvider,
                        plan: values.plan,
                        resendInvite: values.resendInvite,
                        sport: values.sport,
                        timezone: values.timezone,
                        zipCode: values.zipCode,
                        mailingAddress: values.mailingAddress,
                        mailingAddress2: values.mailingAddress2,
                        mailingCity: values.mailingCity,
                        mailingState: values.mailingState,
                        mailingZip: values.mailingZip,
                        mailingCountry: values.mailingCountry,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 9, , 10]);
                    if (!selectedOrganizationId) return [3 /*break*/, 6];
                    if (!employeeView) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateOrganizationAsAdmin({ variables: variables })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, updateOrganization({ variables: variables })];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    setFeedbackMessage({
                        variables: {
                            message: "Successfully updated organization settings!",
                            autoclose: true,
                            isError: false,
                        },
                    });
                    return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, createOrganization({ variables: variables })];
                case 7:
                    _a.sent();
                    setFeedbackMessage({
                        variables: {
                            message: "The org " + values.name + " has been created.",
                            autoclose: true,
                            isError: false,
                        },
                    });
                    _a.label = 8;
                case 8:
                    hide(true);
                    return [3 /*break*/, 10];
                case 9:
                    e_1 = _a.sent();
                    errorMessage = selectedOrganizationId
                        ? "Something went wrong while trying to update your organization. Please try again!"
                        : "Something went wrong while trying to create your organization. Please try again!";
                    setFeedbackMessage({
                        variables: {
                            message: errorMessage,
                            autoclose: true,
                            isError: true,
                        },
                    });
                    console.warn("Unable to validate/submit organization form.", e_1);
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); };
    var hide = function (updated) {
        onFinish === null || onFinish === void 0 ? void 0 : onFinish(updated);
    };
    var organizationForm = react_hook_form_1.useForm();
    var setupFormDefaults = React.useCallback(function (data) {
        var organization = serialization_1.toType(data === null || data === void 0 ? void 0 : data.showOrganization, organization_1.default);
        var invite = organization.ownerInvite || { firstName: null, lastName: null, email: null, accepted: null };
        Object.entries({ name: organization.name,
            country: organization.country,
            zipCode: organization.zipCode,
            timezone: organization.timezone,
            sport: organization.sport,
            mailingAddress: organization.mailingAddress,
            mailingAddress2: organization.mailingAddress2,
            mailingCity: organization.mailingCity,
            mailingState: organization.mailingState,
            mailingCountry: organization.mailingCountry,
            mailingZip: organization.mailingZip,
            ownerFirstName: invite.firstName,
            ownerLastName: invite.lastName,
            ownerEmail: invite.email,
            inviteAccepted: invite.accepted,
            businessType: organization.businessType,
            plan: organization.plan || 14,
            paymentProvider: organization.paymentProvider || "stripe",
            numberOfTeamsPaidFor: organization.numberOfTeamsPaidFor,
            notes: organization.notes,
            roles: organization.roles }).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            organizationForm.setValue(key, value);
        });
    }, []);
    var isSubmitting = createOrganizationResponse.loading ||
        updateOrganizationResponse.loading ||
        updateOrganizationAsAdminResponse.loading;
    var getOrganization = react_apollo_1.useQuery(QueryOrganization.QUERY, {
        variables: { organizationId: selectedOrganizationId },
        skip: !selectedOrganizationId,
        onCompleted: setupFormDefaults,
    });
    form_element_hook_1.useFormDefaults(getOrganization.data, setupFormDefaults, [
        getOrganization.called,
        getOrganization.loading,
    ]);
    var handleSubmit = organizationForm.handleSubmit, register = organizationForm.register;
    return (React.createElement("form", { className: isModal ? "" : "u-maxWidthMd", onSubmit: handleSubmit(submit) }, getOrganization.called == false ||
        (apollo_helpers_1.isQueryFinished(getOrganization) && (React.createElement("div", { id: "organization-create-editor-content", className: "page-content" },
            React.createElement(teamsnap_ui_1.Panel, { mods: "Panel--form" },
                React.createElement(teamsnap_ui_1.PanelHeader, { title: "Organization Details" }),
                React.createElement(teamsnap_ui_1.PanelBody, null,
                    React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "Panel-cell--header u-size3of12 u-flex" },
                            React.createElement("h4", null, "Name")),
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size9of12" },
                            React.createElement(CreateElement, { inputRef: register({
                                    required: "You must enter a name for the organization.",
                                }), useHookResponse: organizationForm, type: "text", field: "name", label: "Organization Name", labelHidden: true, placeholder: "Organization name" }))),
                    employeeView && (React.createElement(org_admin_fields_1.default, { selectedOrganizationId: selectedOrganizationId, useHookResponse: organizationForm })),
                    React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "Panel-cell--header u-size3of12 u-flex" },
                            React.createElement("h4", null, "Location")),
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size9of12" },
                            React.createElement(teamsnap_ui_1.Grid, { isWithGutter: true },
                                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size6of12" },
                                    React.createElement(CreateElement, { useHookResponse: organizationForm, inputRef: register({
                                            required: "Can't be blank.",
                                        }), type: "country", field: "country", placeholder: "Country", label: React.createElement("div", null,
                                            "Country",
                                            React.createElement("div", { className: "u-textNormal u-fontSizeSm" }, "Determines default currency for payments")) })),
                                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size6of12" },
                                    React.createElement(CreateElement, { useHookResponse: organizationForm, inputRef: register({
                                            required: "Can't be blank.",
                                        }), type: "text", field: "zipCode", placeholder: "Zip/Postal Code", label: React.createElement("div", null,
                                            "Zip/Postal Code",
                                            " ",
                                            React.createElement("div", { className: "u-textNormal u-fontSizeSm" }, "For local weather forcasts")) }))),
                            React.createElement("br", null),
                            React.createElement(teamsnap_ui_1.Cell, { mods: "u-size12of12" },
                                React.createElement(CreateElement, { useHookResponse: organizationForm, inputRef: register({
                                        required: "Can't be blank.",
                                    }), type: "timezone", field: "timezone", placeholder: "Time Zone", label: "Time Zone" })))),
                    React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "Panel-cell--header u-size3of12 u-flex" },
                            React.createElement("h4", null, "Sport")),
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size9of12" },
                            React.createElement(teamsnap_ui_1.Cell, { mods: "u-size12of12" },
                                React.createElement(CreateElement, { useHookResponse: organizationForm, inputRef: register({
                                        required: "Can't be blank.",
                                    }), type: "sport", field: "sport", label: "sport", labelHidden: true, placeholder: "Sport" })))),
                    React.createElement(mailing_address_1.default, { useHookResponse: organizationForm }),
                    employeeView && (React.createElement("span", null,
                        React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "Panel-cell--header u-size3of12 u-flex" },
                                React.createElement("h4", null, "Business Type")),
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size9of12" },
                                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size12of12" },
                                    React.createElement(CreateElement, { useHookResponse: organizationForm, inputRef: register({
                                            required: "Can't be blank.",
                                        }), type: "select", field: "businessType", label: "Business type", labelHidden: true, options: [
                                            { text: "Select a business type", value: "" },
                                            { text: "Non-Profit", value: "non-profit" },
                                            { text: "Individual", value: "individual" },
                                            { text: "Corporation", value: "corporation" },
                                        ] })))),
                        React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "Panel-cell--header u-size3of12 u-flex" },
                                React.createElement("h4", null, "Plan")),
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size9of12" },
                                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size12of12" },
                                    React.createElement(CreateElement, { useHookResponse: organizationForm, inputRef: register({
                                            required: "Can't be blank.",
                                        }), type: "select", field: "plan", label: "Plan", labelHidden: true, options: [
                                            { text: "Free Plan", value: "14" },
                                            { text: "Basic Plan", value: "41" },
                                            { text: "Premium Plan", value: "56" },
                                            { text: "Ultra Plan", value: "33" },
                                            { text: "21 Day Free Trial", value: "17" },
                                        ] })))),
                        React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "Panel-cell--header u-size3of12 u-flex" },
                                React.createElement("h4", null, "Payment Provider")),
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size9of12" },
                                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size12of12" },
                                    React.createElement(CreateElement, { useHookResponse: organizationForm, inputRef: register({
                                            required: "Can't be blank.",
                                        }), type: "select", field: "paymentProvider", label: "Payment provider", labelHidden: true, options: [{ text: "Stripe", value: "stripe" }] })))),
                        React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "Panel-cell--header u-size3of12 u-flex" },
                                React.createElement("h4", null, "Plan Paid for This Number of Teams")),
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size9of12" },
                                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size12of12" },
                                    React.createElement(CreateElement, { useHookResponse: organizationForm, inputRef: register({
                                            required: false,
                                            validate: function (value) { return !value || validation_1.validInteger(value) || "Please input a valid integer"; },
                                        }), type: "text", label: "Number of teams paid for", labelHidden: true, field: "numberOfTeamsPaidFor" })))),
                        React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "Panel-cell--header u-size3of12 u-flex" },
                                React.createElement("h4", null, "Notes")),
                            React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size9of12" },
                                React.createElement(CreateElement, { useHookResponse: organizationForm, inputRef: register({
                                        required: false,
                                    }), type: "textarea", field: "notes", label: "Notes", labelHidden: true })))))),
                React.createElement(teamsnap_ui_1.PanelFooter, { mods: "u-textLeft" },
                    React.createElement("div", { className: "button-list" },
                        isModal ? (React.createElement(teamsnap_ui_1.Button, { mods: "Button--negative", icon: "dismiss", onClick: hide }, "Cancel")) : null,
                        React.createElement(teamsnap_ui_1.Button, { isDisabled: isSubmitting, color: "primary", icon: isSubmitting ? null : "check", type: "submit" },
                            isSubmitting && React.createElement(teamsnap_ui_1.Loader, { type: "spin", style: { width: "13px", height: "13px" } }),
                            selectedOrganizationId ? "Update" : "Create",
                            " Organization")))))))));
};
exports.default = OrganizationEditForm;
//# sourceMappingURL=organization-edit-form.js.map